module.exports = __webpack_public_path__ + "static/img/ELITE Logo.bb8f315.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ELITE Logo.svg
// module id = 11
// module chunks = 1